<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">
        {{ topTitle }}
      </div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce } from "@/utils/myUtils";
import { outsorReturnDoc_outsorReturnDocList } from "@/api/myController/outsourcing";
export default {
  name: "outsourcingProduct_return",
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      type: 1,
      topTitle: "产品委外退料",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      changeList: [],
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情"],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 0,
          name: "退料单号",
          value: "outsourcingReturnDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          color: "#409eff",
          sortable: true,
        },
        {
          id: 0,
          name: "全局搜索码",
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 1,
          name: "委外订单号",
          value: "baseOutsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: "退料人",
          value: "baseDrawerName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 80,
        },
        {
          id: 3,
          name: "退货确认人",
          value: "baseConfirmmanName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 4,
          name: "退料日期",
          value: "baseReturnTime",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 6,
          name: "物料编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 120,
          sortable: true,
        },
        {
          id: 7,
          name: "物料名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionList: [],
          canEdit: false,
          width: 100,
        },
        {
          id: 8,
          name: "规格",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 180,
        },
        {
          id: 6,
          name: "单位",
          value: "baseMaterialUnitName",
          dataType: "text",
          fixedState: false,
          isShow: true,
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: "客户料号",
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 9,
          name: "退料数量",
          value: "baseReturnQuantity",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 180,
        },
        {
          id: 14,
          name: "状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 100,
        },
        {
          id: 11,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 180,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      outsorReturnDoc_outsorReturnDocList({
        orderParam: [this.orderParam],
        outsorReturnDocDetailFilter: this.titleData,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();

        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.homeIndex = 49;
          this.htmlDataDialogState.show2 = true;
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "":
          break;

        default:
          break;
      }
    },
    changeType() {
      this.type = command;
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
